"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.concat.js");

var _isNotString = _interopRequireDefault(require("./helpers/isNotString"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * truncate a string and add ellipses
 *
 * @param str - text string
 * @param length - # of characters to truncate to
 * @param ell - should append ellipses
 * @example
 * truncate("I thought up an ending for my book. 'And he lives happily ever after, till the end of his days.", 35, false) =>
 * 'I thought up an ending for my book.'
 */
var truncate = function truncate(str, length) {
  var ell = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if ((0, _isNotString.default)(str)) return '';
  var copyLength = length;
  if (str.length <= copyLength) return str; // Remove character if last character would be space

  if (str[length - 1] === ' ') copyLength -= 1;
  var string = str.substring(0, copyLength);
  return ell ? string.concat('…') : string;
};

var _default = truncate;
exports.default = _default;